import React, { Component } from 'react'
import { Button } from 'react-bootstrap'
import autobind from 'autobind-decorator'
import RequiredLabel from './requiredLabel'
import { getObjVal } from '../utils'
import PropTypes from 'prop-types'
import Input from '../components/elements/input'

@autobind
export default class CounterButton extends Component {
  static defaultProps = {
    label: '',
    value: 0,
    required: false,
    onIncrement: () => null,
    onDecrement: () => null,
    plusDisabled: false
  }

  static propTypes = {
    value: PropTypes.number.isRequired,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    onIncrement: PropTypes.func,
    onDecrement: PropTypes.func,
    plusDisabled: PropTypes.bool
  }

  increment() {
    this.props.onChange(parseInt(getObjVal(this.props.value)) + 1)
    this.props.onIncrement()
  }

  decrement() {
    this.props.onChange(parseInt(getObjVal(this.props.value)) - 1)
    this.props.onDecrement()
  }

  render() {
    let {
      value,
      maxValue,
      minValue,
      label,
      required,
      plusDisabled,
      testId
    } = this.props
    let disablePlusButton = plusDisabled || value >= maxValue
    let minusDisabled = value <= minValue

    let minusButton = (
      <Button disabled={minusDisabled} onClick={this.decrement}>
        -
      </Button>
    )
    let plusButton = (
      <Button
        data-test-id={testId}
        disabled={disablePlusButton}
        onClick={this.increment}
      >
        +
      </Button>
    )
    return (
      <div className='counter-button'>
        <Input
          type='text'
          label={<RequiredLabel label={label} required={required} />}
          buttonBefore={minusButton}
          buttonAfter={plusButton}
          value={value}
          readOnly
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/counterButton.js